module.exports = __webpack_public_path__ + "media/pick_five.5136b60b.mp3";